import { DEFAULT_LOCALE } from "../constants/defaultLocale";

export default function getLocale() {
  const lang = document.querySelector("html").getAttribute("lang");

  if (lang === "sv-SE") {
    return "sv";
  }

  if (lang === "nb-NO") {
    return "no";
  }

  if (lang === "fi-FI") {
    return "fi";
  }

  // Returns default fallback locale
  return DEFAULT_LOCALE;
}
